<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.ADD' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      #form
      fxLayout="column"
      autocomplete="off"
      class="tab-locations field-dialog__content__scroll"
      fusePerfectScrollbar
    >
      <div class="field-outline-form">
        <div class="search-bar">
          <mat-form-field appearance="outline">
            <mat-label> {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINK.SEARCH' | translate }} </mat-label>
            <mat-icon matPrefix color="primary">search</mat-icon>
            <input matInput [formControl]="searchInput" [disabled]="isLoading" />
            <mat-hint>
              {{ 'GROUPS.DIALOG.TABS.LOCATIONS.SEARCH_SUGGESTION' | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="tab-locations__title-wrapper">
        <p class="tab-locations__title-text">
          {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINK.TITLE' | translate }} ({{ page?.totalCount || 0 }})
        </p>

        <mat-checkbox
          data-cy="select-all-checkbox"
          *ngIf="page?.items?.length"
          [disabled]="isLoading || isPageChanging || isSaving"
          [checked]="isAllSelected || linkAllLocations"
          (change)="toggleAllSelected($event.checked)"
        >
        </mat-checkbox>
      </div>

      <div class="flex flex-col select-info-banner">
        <app-select-info-banner
          class="select-info-banner"
          *ngIf="isAllSelected || linkAllLocations"
          [totalItems]="page?.totalCount"
          [selectAllItems]="selectAllLocations.bind(this)"
          [linkAllItems]="linkAllLocations"
        ></app-select-info-banner>
      </div>

      <ng-container *ngIf="isLoading; else pageTemplate">
        <div class="loading">
          <mat-spinner class="loading__spinner" diameter="64"></mat-spinner>
          <span class="loading__text"> {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LOADING' | translate }}</span>
        </div>
      </ng-container>

      <ng-template #pageTemplate>
        <div class="tab-locations__body">
          <ng-container *ngIf="page.items.length; else noLocations">
            <div
              class="card tab-locations__body__card"
              *ngFor="let location of page.items"
              fxLayout="row"
              fxLayout="space-between center"
              fxLayoutGap="16px"
            >
              <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
                <p class="tab-locations__body__card__name" [class.archived]="location.archived">
                  {{ location.name }}
                  <span *ngIf="location.archived">
                    ({{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.ARCHIVED' | translate }})
                  </span>
                </p>
                <p class="tab-locations__body__card__email">
                  {{ location.address.formattedAddress | removeLocationName: location.name }}
                </p>
              </div>

              <div fxLayout="column" fxLayoutAlign="center start">
                <p
                  class="tab-locations__body__card__linked"
                  *ngIf="location.groupsConnection.items.length; else linkLocationTemplate"
                >
                  {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINK.ALREADY_LINKED' | translate }}
                </p>

                <ng-template #linkLocationTemplate>
                  <mat-checkbox
                    (change)="toggleLocationLinkedToGroup($event.checked, location)"
                    [disabled]="isLoading"
                    [checked]="locationToAdd.has(location.id) || linkAllLocations"
                  ></mat-checkbox>
                </ng-template>
              </div>
            </div>

            <div class="tab-locations__paginator-wrapper">
              <fc-paginator
                class="tab-locations__paginator"
                #paginator
                [pageSize]="pageSize"
                [totalCount]="page?.totalCount"
                [currentPageLength]="page?.items.length"
                [isLoading]="isPageChanging"
                (page)="onPageChange($event)"
              >
              </fc-paginator>
            </div>
          </ng-container>
          <ng-template #noLocations>
            <p class="tab-locations__body__not-found-title">
              {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINK.NOT_FOUND' | translate }}
            </p>
          </ng-template>
        </div>
      </ng-template>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout="row">
    <button class="field-background" mat-raised-button (click)="continue()" [disabled]="isLoading || isSaving">
      {{ 'GROUPS.DIALOG.LINK' | translate }}
    </button>

    <button class="field-background--stroked" mat-stroked-button mat-dialog-close>
      {{ 'GROUPS.DIALOG.BACK' | translate }}
    </button>
  </div>
</div>
